import { Route } from "react-router-dom";

import {
  ADD_ACCOUNT_TRANSACTION,
  ADD_EMPLOYEE_SALARY,
  ADD_USER_PAYMENT,
  ADD_VENDOR_PAYMENT,
  ADD_WORKER_PAYMENT,
  CREATE_SUBCONTRACTOR_TRANSACTION,
  EDIT_ACCOUNT_TRANSACTION,
  EDIT_EMPLOYEE_SALARY,
  EDIT_SUBCONTRACTOR_TRANSACTION,
  EDIT_USER_PAYMENT,
  EDIT_VENDOR_PAYMENT,
  EDIT_WORKER_PAYMENT,
  VIEW_USER_STATEMENT,
} from "src/constants";
import { TRANSACTION_ROUTES } from "src/pages/transaction/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { AddTransaction } from "./AddTransaction.page";
import { EditTransaction } from "./EditTransaction.page";
import { SingleTransaction } from "./SingleTransaction.page";

/** Route tree for the transaction module, mounted under `/transaction`. */
export const transactionRoutes = (
  <Route path={TRANSACTION_ROUTES.root}>
    <Route
      path={TRANSACTION_ROUTES.details}
      element={<ProtectedRoute permissions={[VIEW_USER_STATEMENT]} component={SingleTransaction} />}
    />
    <Route
      path={TRANSACTION_ROUTES.add}
      element={
        <ProtectedRoute
          permissions={[
            ADD_WORKER_PAYMENT,
            ADD_EMPLOYEE_SALARY,
            ADD_VENDOR_PAYMENT,
            CREATE_SUBCONTRACTOR_TRANSACTION,
            ADD_USER_PAYMENT,
            ADD_ACCOUNT_TRANSACTION,
          ]}
          component={AddTransaction}
        />
      }
    />
    <Route
      path={TRANSACTION_ROUTES.edit}
      element={
        <ProtectedRoute
          permissions={[
            EDIT_WORKER_PAYMENT,
            EDIT_EMPLOYEE_SALARY,
            EDIT_VENDOR_PAYMENT,
            EDIT_SUBCONTRACTOR_TRANSACTION,
            EDIT_USER_PAYMENT,
            EDIT_ACCOUNT_TRANSACTION,
          ]}
          component={EditTransaction}
        />
      }
    />
  </Route>
);
